// extracted by mini-css-extract-plugin
export default {"downloadOverlay":"Reports_downloadOverlay__w9eOT","downloadMsg":"Reports_downloadMsg__sdUFV"};